<template>
  <div class="footer">
    footer
  </div>
</template>

<script>
export default {
  data: function () {
    return {}
  }
}
</script>

<style scoped>
</style>
